let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dlZSj"), load("6EQss"), load("6cVEd")]).then(() => parcelRequire('bSBwg'));